export default __webpack_public_path__ + "static/media/9.14d02d82.JPG";